<template lang="pug">
      img(v-if="signedSrc" :src="signedSrc" :alt="alt")
</template>
<script>
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import * as log from 'loglevel';

const ACLTypes = {
  PUBLIC: 'public',
  PRIVATE: 'private',
};

export default {
  name: 'aiqImage',
  inject: ['getSignedSource'],
  data() {
    return {
      signedSrc: null,
    };
  },
  props: {
    src: {
      type: String,
      default: '',
    },
    acl: {
      type: String,
      default: ACLTypes.PUBLIC,
    },
    imageKey: {
      type: String,
      default: '',
    },
    bucket: {
      type: String,
      default: '',
    },
    file: {
      type: Object,
      default: null,
    },
    alt: {
      type: String,
      default: '',
    },
  },
  watch: {
    file(newVal) {
      return this.updateFile(newVal);
    },
  },
  async mounted() {
    if (this.file) {
      await this.updateFile(this.file);
    } else if (this.src && this.acl) {
      // This wouldn't be reactive to source change
      await this.updateSrc(this.src, this.acl, this.bucket, this.imageKey);
    } else {
      log.warn('Unwanted image state', this.file, this.src, this.acl);
    }
  },
  methods: {
    async updateSrc(defaultSrc, acl, bucket, key) {
      if (isEqual(acl, ACLTypes.PUBLIC)) {
        this.signedSrc = defaultSrc;
      } else if (!isEmpty(bucket) && !isEmpty(key)) {
        this.signedSrc = await this.getSignedSource(bucket, key);
      } else {
        log.warn('Unable to update image url:', defaultSrc, acl, bucket, key);
      }
    },
    async updateFile(file) {
      if (!file) {
        return;
      }

      const {
        acl, url, bucket, key,
      } = file;
      await this.updateSrc(url, acl, bucket, key);
    },
  },
};
</script>
